import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { AddInventoryWriteOff$Params } from 'src/api/generated/fn/inventory/add-inventory-write-off';
import { GetStockItem$Params } from 'src/api/generated/fn/inventory/get-stock-item';
import { AddInventoryWriteOffDto } from 'src/api/generated/models/Digiwork/MaitreD/Pos/DTO/WriteOffs/add-inventory-write-off-dto';
import { InventoryWriteOffDto } from 'src/api/generated/models/Digiwork/MaitreD/Pos/DTO/WriteOffs/inventory-write-off-dto';
import { InventoryService } from 'src/api/generated/services';

@Component({
  selector: 'app-item-write-off',
  templateUrl: './item-write-off.component.html',
  styleUrls: ['./item-write-off.component.scss']
})
export class ItemWriteOffComponent implements OnInit {

  stockItemId: string;
  inventoryId: string;
  writeOff: InventoryWriteOffDto = {} as InventoryWriteOffDto;

  constructor(private ref: DynamicDialogRef,
              private config: DynamicDialogConfig,
              private inventoryService: InventoryService) {
      
      if (this.config.data != undefined) {
        if(this.config.data.stockItemId) {
          this.stockItemId = this.config.data.stockItemId;        
          const params: GetStockItem$Params = { stockItemId: this.config.data.stockItemId };
          this.inventoryService.getStockItem(params).subscribe( response => this.writeOff.item = response );   
        }  
        if(this.config.data.inventoryId) {
          this.inventoryId = this.config.data.inventoryId;
        }     
      }
  }

  ngOnInit(): void {
  }
  
  apply(f: NgForm){
    if(f.valid){
      const addWriteOff: AddInventoryWriteOffDto = { quantity: this.writeOff.quantity, reason: this.writeOff.reason, stockItem: this.writeOff.item };
      const params: AddInventoryWriteOff$Params = { inventoryId: this.inventoryId, body: addWriteOff };
      this.inventoryService.addInventoryWriteOff(params).subscribe( {next: response => this.ref.close(true), error: errorResponse => this.ref.close(errorResponse)});
    }
  }

  close(){
    this.ref.close(null);
  }
}
